module.exports = __webpack_public_path__ + "img/icon-share-arrow.3867c6d1.png";